const TaxFeeAppliedTo = {
  Cost: 'Cost',
  Revenue: 'Revenue',
  Both: 'Both'
};

export default TaxFeeAppliedTo;
